import React from 'react';

const linePadding = padding => {
  switch (padding) {
    case 'thin':   return  '6px 0px';
    case 'normal': return  '8px 0px';
    case 'thick':  return '10px 0px';
    default:       return  '8px 0px';
  }
};

class PriceLine extends React.Component {
  
  render() {

    const { 
      backgroundColor, 
      linePadding: linePaddingProp, 
      left, right
    } = this.props;

    return (
      <div className="Price-info-line" style={{ 
        backgroundColor: backgroundColor,
        padding: linePadding(linePaddingProp) }}
      >
        <div className="Price-info-text">   {left}  </div>
        <div className="Price-info-number"> {right} </div>
      </div>
    );
  }
};

PriceLine.defaultProps = {
  left: '', 
  right: '',
  linePadding: 'normal', 
  backgroundColor:'var(--white-color)',
};

export default PriceLine;